import React, { useEffect, useState } from 'react';
import { useLazyDataModel } from "@thd-nucleus/data-sources";
import { NOT_FETCHED } from "../../AddToConstants";
import { useStore } from "@thd-nucleus/experience-context";


export const AnalyticsPriceFetcher = ({
  children,
  selectedListItems,
  updateBasePrice
}) => {
  const BATCH_SIZE_LIMIT = 16;
  const { storeId, storeZip } = useStore({ varnish: true });
  const [itemPriceMap, setItemPriceMap] = useState(new Map());
  const [
    fetchListProducts, { data: productData, variables, error }
  ] = useLazyDataModel('products', {});

  useEffect(() => {
    const listItems = Object.values(selectedListItems);
    const listItemsWithMissingPrice = listItems.filter(
      items => items.some(item => item.basePrice === NOT_FETCHED)
    );
    if (listItemsWithMissingPrice.length > 0) {
      const firstListItems = listItemsWithMissingPrice[0]?.filter(
        item => item.basePrice === NOT_FETCHED
      );
      const itemIds = firstListItems.slice(0, BATCH_SIZE_LIMIT)?.map((item) => item.itemId);
      const itemsKey = itemIds.join(':');
      if (itemPriceMap.has(itemsKey)) {
        updateBasePrice(itemPriceMap.get(itemsKey));
      } else {
        fetchListProducts({
          variables: {
            itemIds,
            storeId,
            zipCode: storeZip
          }
        });
      }
    }
  }, [selectedListItems]);

  useEffect(() => {
    if (variables?.itemIds && (productData?.products || Boolean(error))) {
      const productsMap = new Map();
      (productData?.products || []).forEach(product => productsMap.set(product.itemId, product));
      const itemBasePriceMap = new Map();
      variables.itemIds.forEach(itemId => {
        const product = productsMap.get(itemId);
        const basePrice = product?.pricing?.value || 'n/a';
        itemBasePriceMap.set(itemId, basePrice);
      });
      updateBasePrice(itemBasePriceMap);
      setItemPriceMap(prevMap => {
        const newMap = new Map(prevMap);
        const itemsKey = variables.itemIds.join(':');
        newMap.set(itemsKey, itemBasePriceMap);
        return newMap;
      });
    }
  }, [productData, error])

  return (
    <>
      {
        children
      }
    </>
  )
}
